import fetch from 'isomorphic-fetch';
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GetTokens } from '../types';

export const createApolloClient = (uri: string, getTokens: GetTokens) => {
  const httpLink = createHttpLink({ uri, fetch });

  const authLink = setContext(async (_, { headers }) => {
    const { accessToken } = await getTokens();

    return {
      headers: {
        ...headers,
        authorization: `Bearer ${accessToken}`,
      },
    };
  });

  return new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
  });
};
